<form class="register-form" name="registrationForm" [formGroup]="registrationForm">

    <div class="register-name">

        <rpc-input class="register-form-input" [appearance]="'fill'" [label]="'REGISTRATION_FORM.FIELDS.FIRST_NAME'"
            [options]="firstNameControlOptions">
        </rpc-input>

        <rpc-input class="register-form-input" [appearance]="'fill'" [label]="'REGISTRATION_FORM.FIELDS.LAST_NAME'"
            [options]="lastNameControlOptions">
        </rpc-input>

    </div>

    <rpc-input class="register-form-input" [type]="'email'" [appearance]="'fill'"
        [label]="'REGISTRATION_FORM.FIELDS.EMAIL'" [options]="emailControlOptions" [disabled]="true">
    </rpc-input>

    <phone-form-input class="register-form-phone" [appearance]="'fill'" [phoneNumberInfo]="customerData.phoneNumberInfo"
        [isPhoneRequired]="false" [isFormatValidationRequired]="true" [parentForm]="registrationForm"
        [controlName]="'phoneNumber'" [countriesPhoneInfo]="countriesPhoneInfo()">
    </phone-form-input>

    @if (!isWorkspaceAddition) {
    <password class="register-form-input" [label]="'REGISTRATION_FORM.FIELDS.PASSWORD'"
        [options]="passwordControlOptions">
    </password>

    <password class="register-form-input" [label]="'REGISTRATION_FORM.FIELDS.PASSWORD_CONFIRM'"
        [options]="passwordConfirmControlOptions">
    </password>
    }

    <div class="register-password-form-terms">

        <rpc-checkbox [state]="agreeToTermsAndConditions" (changed)="onAgreeToTermsAndConditionsChange($event)">
            <span class="register-password-checkbox-text">
                {{'REGISTRATION_FORM.TITLES.AGREE_TERMS' | translate}}
                <br />
                <a [href]="termsAndConditionsLink" target="_blank" rel="nofollow">
                    {{'REGISTRATION_FORM.TITLES.TERMS_CONDITIONS' | translate}}
                </a>
                {{'REGISTRATION_FORM.TITLES.AND' | translate}}
                <a [href]="privacyPolicyLink" target="_blank" rel="nofollow">
                    {{'REGISTRATION_FORM.TITLES.PRIVACY_POLICY' | translate}}
                </a>
            </span>
        </rpc-checkbox>

    </div>

    <div class="register-footer">

        <rpc-button [color]="'accent'" [isMainButton]="true"
            [disabled]="registrationForm.invalid || agreeToTermsAndConditions !== 'checked'" [appearanceType]="'flat'"
            [text]=" isWorkspaceAddition ? 'REGISTRATION_FORM.BUTTONS.WORKSPACE_ADD' : 'REGISTRATION_FORM.BUTTONS.CREATE'"
            (clicked)="onSubmit()">
        </rpc-button>

    </div>

</form>